;(window.HB = window.HB || {}).loadJS = function (
  url,
  type = "text/javascript",
) {
  const s = document.createElement("script")
  s.src = url
  s.type = type
  s.async = true
  const loaded = new Promise((resolve, reject) => {
    s.addEventListener("load", resolve)
    s.addEventListener("error", reject)
  })
  document.head.append(s)
  return loaded
}
